import React, { useState } from 'react';
import { Box, Stack, Typography, Container } from '@mui/material';
import PropTypes from 'prop-types';

import CustomerTable from './CustomerTable';
import ReportingContainer from '../Reporting/ReportingContainer';
import MaintenanceBannerDetails from './MaintenanceBannerDetails';
import SideNav from './SideNav';

import CustomerIcon from '@mui/icons-material/Person';
import ReportsIcon from '@mui/icons-material/Description';
import BuildIcon from '@mui/icons-material/Build';

import { is360PayStaff } from '../../utils/roles';

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      className="global-selected-screen-tab"
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default function SelectCustomer() {
  const [value, setValue] = useState(0);

  const showMaintenanceBannerTab = sessionStorage.getItem('department') === 'IT';

  const tabData = [
    { label: 'Select a customer', id: 'select-customer', icon: <CustomerIcon /> },
    ...(is360PayStaff() ? [] : [{ label: 'Reports', id: 'reports', icon: <ReportsIcon /> }]),
    ...(showMaintenanceBannerTab
      ? [
          {
            label: 'Maintenance Banner',
            id: 'maintenance-banner',
            icon: <BuildIcon />,
          },
        ]
      : []),
  ];

  return (
    <Container maxWidth="xl" sx={{ px: 4, mt: 4, mb: 4 }}>
      <Stack direction="row" gap={2} className="global-wrapper select-customer">
        <div className="display-as-row-centered">
          <SideNav heading="Settings" tabs={tabData} setValue={setValue} value={value} />

          <TabPanel index={0} value={value}>
            <CustomerTable />
          </TabPanel>
          <TabPanel index={1} value={value}>
            <ReportingContainer />
          </TabPanel>
          {showMaintenanceBannerTab && (
            <TabPanel index={2} value={value}>
              <MaintenanceBannerDetails />
            </TabPanel>
          )}
        </div>
      </Stack>
    </Container>
  );
}

TabPanel.propTypes = {
  children: PropTypes.object,
  value: PropTypes.number,
  index: PropTypes.number,
};
